<ion-content class="glass-onboarding">
  <div class="onboarding-wrapper">
    <div class="onboarding-card">
      <img src="assets/icon/favicon.ico" alt="Logo" class="onboarding-logo" />
      <h1>{{ 'mainauth.onboarding.welcome' | translate }}</h1>
      <p class="subtitle">{{ 'mainauth.onboarding.subtitle' | translate }}</p>

      @if (error) {
        <div class="error-box">{{ error }}</div>
      }

      @if (waitFailed) {
        <!-- Registration was accepted but the profile did not show up in time: look again, do not ask for the data twice. -->
        <div class="onboarding-progress">
          <ion-button fill="outline" (click)="waitForProfile()">{{ 'mainauth.onboarding.retry' | translate }}</ion-button>
        </div>
      } @else if (autoCompleting) {
        <!-- Invited user, or the profile is being created: name and email are known, so there is nothing to ask. -->
        <div class="onboarding-progress">
          <ion-spinner name="crescent"></ion-spinner>
          <p>{{ 'mainauth.onboarding.settingUp' | translate }}</p>
        </div>
      } @else {
      <form (ngSubmit)="submit()" class="onboarding-form">
        <ion-item lines="none">
          <ion-label position="stacked">{{ 'mainauth.onboarding.firstName' | translate }}</ion-label>
          <ion-input [(ngModel)]="firstName" name="firstName" type="text" required placeholder="Max"></ion-input>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">{{ 'mainauth.onboarding.lastName' | translate }}</ion-label>
          <ion-input [(ngModel)]="lastName" name="lastName" type="text" required placeholder="Mustermann"></ion-input>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked"
                     [appTooltip]="'mainauth.onboarding.tt.displayName' | translate"
                     tooltipPosition="right">{{ 'mainauth.onboarding.displayName' | translate }}</ion-label>
          <ion-input [(ngModel)]="displayName" name="displayName" type="text" [placeholder]="'mainauth.onboarding.displayNamePlaceholder' | translate"></ion-input>
        </ion-item>

        <ion-button expand="block" type="submit" [disabled]="loading" class="submit-btn"
                    [appTooltip]="'mainauth.onboarding.tt.save' | translate">
          @if (loading) {
            <ion-spinner name="crescent" slot="start"></ion-spinner>
          }
          {{ (loading ? 'mainauth.onboarding.saving' : 'mainauth.onboarding.saveProfile') | translate }}
        </ion-button>
      </form>
      }
    </div>
  </div>
</ion-content>
